var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
import { parsePhoneNumber } from 'libphonenumber-js';
var UtilsService = /** @class */ (function () {
    function UtilsService() {
    }
    UtilsService.prototype.getFormattedPhoneNumber = function (phoneNumber) {
        try {
            // if no data, then return success and empty
            if (!phoneNumber || phoneNumber.length === 0) {
                return {
                    success: true,
                    data: {
                        number: '',
                        extension: '',
                    },
                };
            }
            var parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US');
            var nationalNumber = parsedPhoneNumber.nationalNumber;
            var extension = parsedPhoneNumber.ext;
            var reformattedNumber = parsedPhoneNumber.ext
                ? parsedPhoneNumber.nationalNumber + "x" + parsedPhoneNumber.ext
                : parsedPhoneNumber.nationalNumber;
            // if the phone number has not been parsed fully
            if (reformattedNumber.length !== phoneNumber.length) {
                throw Error('Complete number has not been parsed');
            }
            // return the parsed phone number
            return {
                success: true,
                data: {
                    number: nationalNumber,
                    extension: extension,
                },
            };
        }
        catch (error) {
            // try and manually parse the phone number
            if (phoneNumber.includes('x')) {
                console.warn('Auto-parsing failed, attempting to parse');
                var phoneSplit = phoneNumber.split('x');
                var parsedPhoneNumber = parsePhoneNumber(phoneSplit[0], 'US');
                return {
                    success: true,
                    data: {
                        number: parsedPhoneNumber.nationalNumber,
                        extension: phoneSplit[1],
                    },
                };
            }
            else {
                // not a valid phone number
                console.warn(error);
                return {
                    success: false,
                    message: "Unable to process '" + phoneNumber + "'",
                };
            }
        }
    };
    UtilsService = __decorate([
        injectable()
    ], UtilsService);
    return UtilsService;
}());
export { UtilsService };
